import Vue from 'vue';
import Router from 'vue-router';

import employeeRoutes from './employee';
import adminRoutes from './admin';

Vue.use(Router);

const routes = [
  ...employeeRoutes,
  ...adminRoutes
];

export default new Router({
  mode: 'history',
  routes,
});
